export default {
  profileMenu: {
    en: 'Profile menu',
  },
}
